var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('target',{attrs:{"model":_vm.syncedModel},on:{"update:model":function($event){_vm.syncedModel=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }